(function() {
  function getOptions($product) {
    var $colorWrap = $product.find('[data-color-options]');
    if (!$colorWrap.length) return null;
    try {
      var raw = $colorWrap.attr('data-color-options').replace(/&quot;/g, '"');
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function extractKey(url) {
    if (!url) return '';
    // 取出檔名主體，例如 50453-509_A_SOFTBLUE_STANDARDBLACK
    var match = (url + '').match(/\/([^\/?#]+?)\.(jpg|jpeg|png|webp)/i);
    if (!match) return '';
    return match[1]
      .replace(/[_-]?\d+x\d+/gi, '')
      .replace(/&.*$/, '')
      .toLowerCase();
  }

  function updateHoverByIndex($product, index, options) {
    if (!options || !options.img2_variants || !options.img2_variants[index]) return;
    var img2 = options.img2_variants[index];
    // 有時 img2 有 &width=1，清乾淨比較好
    if (img2.indexOf('&width=') > -1) {
      img2 = img2.split('&width=')[0];
    }
    var $hoverImg = $product.find('img.t4s-product-hover-img');
    if ($hoverImg.length) {
      $hoverImg
        .removeClass('lazyloadt4sed ls-is-cached')
        .addClass('lazyloadt4s')
        .attr('data-srcset', img2)
        .attr('srcset', img2)
        .attr('data-src', img2)
        .attr('src', img2);
    }
  }

  function updateHoverImage($swatch) {
    var $product = $swatch.closest('[data-product-options]');
    if (!$product.length) return;
    var options = getOptions($product);
    if (!options) return;

    var id_variants = options.id_variants || [];
    var vid = $swatch.attr('data-vid') || $swatch.data('vid');
    if (!vid) return;

    var index = id_variants.indexOf(Number(vid));
    if (index < 0) index = id_variants.indexOf(String(vid));
    if (index < 0) return;

    updateHoverByIndex($product, index, options);
  }

  // 根據目前主圖自動對應正確 Hover
  function fixByMainImage($product) {
    var options = getOptions($product);
    if (!options || !options.img_variants || !options.img2_variants) return;

    var $mainImg = $product.find('img.t4s-product-main-img');
    if (!$mainImg.length) return;

    var currentSrc = $mainImg.attr('srcset') || $mainImg.attr('data-srcset') || $mainImg.attr('src') || $mainImg.attr('data-src') || '';
    var currentKey = extractKey(currentSrc);
    if (!currentKey) return;

    var index = -1;
    for (var i = 0; i < options.img_variants.length; i++) {
      var variantKey = extractKey(options.img_variants[i] || '');
      if (variantKey && (currentKey.indexOf(variantKey) !== -1 || variantKey.indexOf(currentKey) !== -1 || currentKey === variantKey)) {
        index = i;
        break;
      }
    }

    if (index >= 0) {
      updateHoverByIndex($product, index, options);
      return true;
    }
    return false;
  }

  // Fallback：用可見 / 第一個 swatch
  function fixByVisibleSwatch($product) {
    var $swatches = $product.find('.t4s-pr-color__item:not([data-img="none"]):not(.is--colors-more)');
    if (!$swatches.length) return;

    var $active = $swatches.filter('.is-swatch--current, .is-swatch--selected, .is--selected, .is-active, [aria-checked="true"]').first();
    if ($active.length) {
      updateHoverImage($active);
      return;
    }

    var $firstVisible = $swatches.filter(':visible').first();
    if ($firstVisible.length) {
      updateHoverImage($firstVisible);
      return;
    }
    updateHoverImage($swatches.first());
  }

  function fixProduct($product) {
    // 優先用主圖比對（最準）
    if (!fixByMainImage($product)) {
      // 比對失敗先用 swatch
      fixByVisibleSwatch($product);
    }
  }

  function fixAllProducts() {
    jQuery('[data-product-options]').each(function() {
      fixProduct(jQuery(this));
    });
  }

  // ===== 一般切換顏色（保持原本可用）=====
  var selector = '.t4s-pr-color__item:not(.is-swatch--current):not([data-img="none"]):not(.is--colors-more)';
  if (window.T4SThemeSP && T4SThemeSP.isTouch) {
    jQuery(document).on('click', selector, function() {
      updateHoverImage(jQuery(this));
    });
  } else {
    jQuery(document).on('mouseenter', selector, function() {
      updateHoverImage(jQuery(this));
    });
  }

  // 產品卡 hover 時再確保一次（保險）
  jQuery(document).on('mouseenter', '[data-product-options]', function() {
    fixProduct(jQuery(this));
  });

  // ===== 初始 + Filter / AJAX =====
  jQuery(document).ready(function() {
    setTimeout(fixAllProducts, 1500);
  });

  jQuery(document).on('ajaxComplete', function() {
    setTimeout(fixAllProducts, 900);
  });

  // Search & Discovery / Facet 常見事件
  jQuery(document).on('facet:updated collection:updated shopify:section:load', function() {
    setTimeout(fixAllProducts, 900);
  });

  // 主題 reinit
  if (window.T4SThemeSP && typeof T4SThemeSP.reinitProductGridItem === 'function') {
    var originalReinit = T4SThemeSP.reinitProductGridItem;
    T4SThemeSP.reinitProductGridItem = function() {
      var result = originalReinit.apply(this, arguments);
      setTimeout(fixAllProducts, 700);
      return result;
    };
  }

  // ===== MutationObserver：主圖一變就立即更新 Hover（最關鍵）=====
  function observeMainImages() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && (mutation.attributeName === 'src' || mutation.attributeName === 'srcset' || mutation.attributeName === 'data-src' || mutation.attributeName === 'data-srcset')) {
          var $img = jQuery(mutation.target);
          if ($img.hasClass('t4s-product-main-img')) {
            var $product = $img.closest('[data-product-options]');
            if ($product.length) {
              setTimeout(function() {
                fixProduct($product);
              }, 50);
            }
          }
        }
      });
    });

    // 監聽現有主圖
    jQuery('img.t4s-product-main-img').each(function() {
      observer.observe(this, { attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'] });
    });

    // 之後新增的產品卡也要監聽
    var gridObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            jQuery(node).find('img.t4s-product-main-img').each(function() {
              observer.observe(this, { attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'] });
            });
            if (jQuery(node).is('img.t4s-product-main-img')) {
              observer.observe(node, { attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'] });
            }
          }
        });
      });
    });

    var $grid = jQuery('.t4s-products, .t4s-product-grid, [data-collection], .collection, main').first();
    if ($grid.length) {
      gridObserver.observe($grid[0], { childList: true, subtree: true });
    }
  }

  jQuery(document).ready(function() {
    setTimeout(observeMainImages, 800);
  });
  jQuery(document).on('ajaxComplete facet:updated', function() {
    setTimeout(observeMainImages, 600);
  });
})();